// src/utils/numberToWords.js

const ONES = [
  "Zero",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const TENS = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

const SCALES = ["", "Thousand", "Million", "Billion", "Trillion"];

function convertHundreds(num) {
  let str = "";

  if (num >= 100) {
    const hundreds = Math.floor(num / 100);
    str += ONES[hundreds] + " Hundred";
    num = num % 100;
    if (num > 0) str += " ";
  }

  if (num >= 20) {
    const tens = Math.floor(num / 10);
    str += TENS[tens];
    const ones = num % 10;
    if (ones > 0) str += " " + ONES[ones];
  } else if (num > 0) {
    str += ONES[num];
  }

  return str;
}

function convertInteger(num) {
  if (num === 0) return "Zero";

  let words = "";
  let scaleIndex = 0;

  while (num > 0) {
    const chunk = num % 1000;
    if (chunk > 0) {
      const chunkWords = convertHundreds(chunk);
      const scaleWord = SCALES[scaleIndex] || "";
      const part =
        chunkWords + (scaleWord ? " " + scaleWord : "");
      words = part + (words ? " " + words : "");
    }
    num = Math.floor(num / 1000);
    scaleIndex++;
  }

  return words;
}

/**
 * Convert a numeric amount (e.g. 1234.56) into words.
 * Example: 1234.56 -> "One Thousand Two Hundred Thirty Four and Fifty Six Cents"
 */
export function numberToWords(amount) {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return "Zero";
  }

  const negative = Number(amount) < 0;
  const absAmount = Math.abs(Number(amount));

  // Work in cents to avoid floating point issues
  const totalCents = Math.round(absAmount * 100);
  const integerPart = Math.floor(totalCents / 100);
  const cents = totalCents % 100;

  let words = convertInteger(integerPart);

  if (cents > 0) {
    const centsWords = convertInteger(cents);
    words += " and " + centsWords + " Cents";
  }

  if (negative) {
    words = "Minus " + words;
  }

  return words;
}
